import { CommandResult, FormApiService } from 'src/common/api-service';
import { AxiosError } from 'axios';
import { CreateContactItem } from './types';

export class ContactFormApiService extends FormApiService {
  constructor() {
    super('Contact');
  }

  public async createContactItem(body: CreateContactItem) {
    try {
      return await super.post<CreateContactItem, CommandResult>(body);
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }
}
